import { useLocation } from "react-router-dom";

export const useRouteParams = () => {
  const { state } = useLocation();

  return state;
};
